import "./AlertBar.scss";
import { useAlertContext } from "../../contexts";
import { AlertType } from "../../models";
import { useEffect, useState } from "react";
import React from "react";

export const AlertBar = React.memo(() => {
	const { alert, clearAlert } = useAlertContext();
	const [backgroundClass, setBackgroundClass] = useState("");
	const [icon, setIcon] = useState("");
	const [closeIcon, setCloseIcon] = useState("");
	const [fadeOut, setFadeOut] = useState(false);

	useEffect(() => {
		switch (alert?.alertType) {
			case AlertType.error:
				setIcon("images/svg/error-red.svg");
				setCloseIcon("images/svg/close-red.svg");
				setBackgroundClass("background-error");
				break;
			case AlertType.success:
				setIcon("images/svg/check-circle-green.svg");
				setCloseIcon("images/svg/close-green.svg");
				setBackgroundClass("background-success");
				break;
			case AlertType.info:
				setIcon("images/svg/information-blue.svg");
				setCloseIcon("images/svg/close-blue.svg");
				setBackgroundClass("background-info");
				break;
			case AlertType.warning:
				setIcon("images/svg/road-sign-warning.svg");
				setCloseIcon("images/svg/close-yellow.svg");
				setBackgroundClass("background-warning");
				break;
			default:
				break;
		}
		setFadeOut(false);
		// if (alert?.timeout) {
		const timer1 = setTimeout(() => {
			setFadeOut(true);

			const timer2 = setTimeout(() => {
				clearAlert();
			}, 1000);

			return () => clearTimeout(timer2);
		}, 1000);

		return () => clearTimeout(timer1);
		// }
	}, [alert, clearAlert]);

	if (!alert) {
		return null;
	}
	return (
		<div className="absolute z-100 w-full">
			<div
				id="alertbar"
				className={`flex justify-center w-full p-4 ps-4 pe-4 gap-4 ${backgroundClass} ${
					fadeOut ? "fade-out" : ""
				}`}
			>
				<img
					src={icon}
					width="32"
					height="32"
					className="align-self-start"
					alt="alert"
				/>

				<div
					className="mt-1"
					dangerouslySetInnerHTML={{ __html: alert.message ?? "" }}
				></div>
				<img
					src={closeIcon}
					width="16"
					height="16"
					className="ml-2 pointer"
					onClick={() => clearAlert()}
					alt="close"
				/>
			</div>
		</div>
	);
});
